import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { getMerchantInfo } from '@util'
import 'antd4/lib/grid/style/index.css'
import { Input } from 'hljd'
import React, { Component } from 'react'
import Planner from '../Planner'

const FormItem = Form.Item

class PlanField extends Component {
  onHotelChange = value => {
    const { hotels, setFieldsValue } = this.props
    const hotel = hotels.find(item => item.name == value)
    if (hotel) {
      setFieldsValue({
        hotel_id: hotel.merchantId,
        hotel_name: value
      })
    } else {
      setFieldsValue({
        hotel_id: '',
        hotel_name: value
      })
    }
  }

  render() {
    const { getFieldDecorator, formItemLayout, form_default } = this.props
    const top_wedding = !!+getMerchantInfo().top_wedding

    return (
      <>
        {getFieldDecorator('hotel_id', {
          initialValue: form_default.hotel_id || ''
        })(<Input type="hidden" />)}
        {top_wedding && (
          <FormItem label="策划师" {...formItemLayout}>
            {getFieldDecorator('person_id', {
              initialValue: form_default.person_id || undefined
            })(<Planner type="planner" />)}
          </FormItem>
        )}
      </>
    )
  }
}

export default PlanField
